import { UserDeviceType } from '../user-devices/userDevices.types';

export interface UserCreationWithCognitoRequestType {
  username: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phoneNumber?: string;
  isLoginAllowed: boolean;
  restaurantId?: number;
  isSubscribed?: boolean;
}

export interface UsernameRequestType {
  username: string;
  firstName?: string;
  lastName?: string;
  restaurantId?: number;
}

export interface LoginWithPosPinType {
  restaurantId: number;
  posPin: number;
}
export interface UserPasswordlessLoginRequestType {
  username: string;
  confirmationCode: string;
  session: string;
  isForgotPwd?: boolean;
  restaurantId?: number;
  deviceId?: string;
  deviceType?: UserDeviceType;
  token?: string | null;
}
export interface UserLoginRequestType {
  username: string;
  password: string;
  restaurantId?: number;
  deviceId?: string;
  deviceType?: UserDeviceType;
  token?: string | null;
  isBiometricLogin?: boolean;
}
export interface UserRefreshTokenWithCognitoRequestType {
  refreshToken: string;
  sub: string;
  restaurantId?: number;
}
export interface UserAttributesRequestType {
  fName?: string;
  lName?: string;
  picture?: string;
  email?: string;
  phone?: string;
  birthdate?: string;
  username: string;
  restaurantId?: string | number;
  isLoginAllowed?: boolean;
}
export interface GoogleAuthTokenRequestType {
  authorizationCode: string;
}
export interface GoogleRefreshTokenRequestType {
  refreshToken: string;
}
export interface ChangePasswordRequestType {
  oldPassword: string;
  newPassword: string;
  accessToken?: string;
}
export interface VerifyAttributeRequestType {
  attributeName: string;
  code: string;
  accessToken: string;
}
export interface ToggleMfaRequestType {
  username: string;
  isEnabled: boolean;
}

export interface Enable2FaEmailRequestType {
  username: string;
  isEmailEnabled: boolean;
}

export interface CreatePasswordType {
  password: string;
  confirmPassword: string;
  currentPassword?: string;
}

export interface addPhoneNumberType {
  addPhoneNumber: string;
}

export interface CognitoVerifierType {
  userPoolId: string;
  tokenUse: 'access';
  clientId: string;
}

export interface kioskLogin {
  mobileNumber: string;
  restaurantId?: number;
}

export enum SocialLoginType {
  GOOGLE = 'Google',
  FACEBOOK = 'Facebook',
}

export interface TokensType {
  accessToken: string;
  idToken: string;
  refreshToken: string;
}

export interface AuthTokenWithSub extends TokensType {
  sub?: string;
}
